let allowTitleChange = false;

export const safeSetTitle = (title: string) => {
  allowTitleChange = true;
  document.title = title;
  allowTitleChange = false;
};

Object.defineProperty(document, "title", {
  get: () => document.querySelector("title")?.textContent || "",
  set: (value) => {
    if (allowTitleChange) {
      document.querySelector("title")!.textContent = value;
    } else {
      console.warn("非法标题修改被阻止:", value);
    }
  },
  configurable: false,
});
